// extracted by mini-css-extract-plugin
export default {"ReadMore":"_2Q5X0th3KnZWuHVLxJztWQ","text":"_1oU5IBX-2n0nwgwzXEXgyO","desc":"_2Ltd79hYewExbkO5JkHp_3","hidden":"_2AEPUh0_oqYVQ-NDI3u1Jk"};